import classNames from 'classnames';
import type { VoidFunctionComponent } from 'react';

import useIncidentStatus, { Impact } from '../../hooks/useIncidentStatus';
import { capitalizeWord } from '../../utils';

import { icons, IconText } from './Icon';
import Link from './Link/Link';

/**
 * Component to show incidents registered with StatusPage.io.
 */
const StatusBanner: VoidFunctionComponent = () => {
  const status = useIncidentStatus();

  if (!status.shouldShow) {
    return null;
  }

  return (
    <div>
      {status.incidents.map((incident) => {
        const alertClass = incident.impact === Impact.MAJOR || incident.impact === Impact.CRITICAL ? 'alert-error' : 'alert-warning';
        return (
          <div key={incident.id} className={classNames('status-banner', 'alert', alertClass, 'text-center')}>
            <strong>{capitalizeWord(incident.impact)}</strong> - {incident.name}
            <Link
              to={incident.shortlink}
              style={{ marginLeft: 15 }}
              openInNewTab
            >
              <IconText
                icon={icons.arrowRight}
                text="Click to view details"
                alignIcon="right"
              />
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default StatusBanner;
